var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound"},[_c('img',{staticClass:"not_img",attrs:{"src":require("@/assets/images/404.png"),"alt":""}}),_c('div',{staticClass:"not_con"},[_c('p',{staticClass:"con_text"},[_vm._v("你要找的页面不见了…")]),(_vm.btnShow)?_c('router-link',{staticClass:"con_home",attrs:{"to":"/"}},[_vm._v("返回首页")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }